@if (presetsStore.templateAuthoring()) {
  <section
    class="border-default bg-surface flex flex-col gap-3 rounded-md border p-3"
    [attr.aria-label]="'features.data.filter_presets.template.section_title' | translate">
    <header class="flex items-center gap-2">
      <i [class]="ICONS.bracketsCurly" class="text-accent-main"></i>
      <span class="text-text-primary text-[12.5px] font-semibold">
        {{ 'features.data.filter_presets.template.section_title' | translate }}
      </span>
    </header>

    <label class="flex flex-col">
      <span class="form-label">{{
        'features.data.filter_presets.template.name_label' | translate
      }}</span>
      <input
        class="form-input rounded-xs"
        type="text"
        [maxLength]="NAME_MAX_LENGTH"
        [value]="name()"
        [placeholder]="'features.data.filter_presets.template.name_placeholder' | translate"
        (input)="name.set($any($event.target).value)" />
    </label>

    <div class="flex flex-col gap-1.5">
      <span class="text-text-secondary text-xs font-medium">
        {{ 'features.data.filter_presets.template.parameters_label' | translate }}
      </span>
      @for (parameter of parameters(); track parameter.name) {
        <div class="flex items-center gap-2">
          <span class="gx-token max-w-[45%] shrink-0 pr-2"
            ><i [class]="ICONS.bracketsCurly" aria-hidden="true"></i
            ><span class="truncate">{{ parameter.name }}</span></span
          >
          <span class="text-text-tertiary shrink-0 text-[11px]">
            {{
              'features.data.filter_presets.template.kinds.' + parameter.kind | translate
            }}
          </span>
          <input
            class="form-input min-w-0 flex-1 rounded-xs py-1 text-xs"
            type="text"
            [class.has-error]="rowIssues().has(parameter.name)"
            [maxLength]="LABEL_MAX_LENGTH"
            [attr.aria-label]="
              'features.data.filter_presets.template.parameter_label_aria'
                | translate: { name: parameter.name }
            "
            [placeholder]="
              'features.data.filter_presets.template.parameter_label_placeholder'
                | translate
            "
            [value]="labelOf(parameter.name)"
            (input)="setLabel(parameter.name, $any($event.target).value)" />
        </div>
        @for (issue of rowIssues().get(parameter.name) ?? []; track $index) {
          <p class="form-help is-error">
            {{
              'features.data.filter_presets.template.issues.' + issue.code
                | translate: { name: issue.name }
            }}
          </p>
        }
      } @empty {
        <p class="text-text-tertiary text-xs">
          {{ 'features.data.filter_presets.template.no_parameters' | translate }}
        </p>
      }
    </div>

    @if (presetsStore.templateParameterRequest(); as request) {
      <app-new-parameter-prompt
        [kind]="request.kind"
        [taken]="parameters()"
        (created)="createParameter(request, $event)"
        (cancelled)="cancelNewParameter()" />
    }

    @for (issue of formIssues(); track $index) {
      <p class="form-help is-error">
        {{
          'features.data.filter_presets.template.issues.' + issue.code
            | translate: { name: issue.name }
        }}
      </p>
    }

    <p class="text-text-tertiary flex items-start gap-1.5 text-[11.5px]">
      <i [class]="ICONS.info" class="mt-0.5 shrink-0"></i>
      {{ 'features.data.filter_presets.template.preview_note' | translate }}
    </p>

    @if (presetsStore.hasSortToSave()) {
      <app-checkbox align="start" [checked]="includeSort()" [onChange]="setIncludeSort">
        <span class="text-text-primary ml-2 text-[12.5px] font-medium">
          {{ 'features.data.filter_presets.template.include_sort_label' | translate }}
          <span class="text-text-tertiary mt-0.5 block text-[11.5px] font-normal">
            {{ 'features.data.filter_presets.template.include_sort_hint' | translate }}
          </span>
        </span>
      </app-checkbox>
    }

    @if (presetsStore.canShareWithDataspace()) {
      <app-checkbox align="start" [checked]="shareWithDataspace()" [onChange]="setShare">
        <span class="text-text-primary ml-2 text-[12.5px] font-medium">
          {{ 'features.data.filter_presets.template.share_label' | translate }}
          <span class="text-text-tertiary mt-0.5 block text-[11.5px] font-normal">
            {{ 'features.data.filter_presets.template.share_hint' | translate }}
          </span>
        </span>
      </app-checkbox>
    }

    @if (error(); as message) {
      <p class="text-danger flex items-start gap-1.5 text-xs" role="alert">
        <i [class]="ICONS.warningCircle" class="mt-0.5 shrink-0"></i>
        {{ message }}
      </p>
    }

    <div class="flex items-center justify-end gap-2">
      <button type="button" class="btn btn-cancel btn-sm" (click)="discard()">
        {{ 'features.data.filter_presets.template.discard' | translate }}
      </button>
      <button
        type="button"
        class="btn btn-primary btn-sm disabled:cursor-not-allowed disabled:opacity-60"
        [disabled]="!canSave()"
        (click)="save()">
        {{
          (saving() ? 'common.saving' : 'features.data.filter_presets.template.save')
            | translate
        }}
      </button>
    </div>
  </section>
}
